import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'OrganizationSettingsPage.Title',
    defaultMessage: 'Organization Settings'
  }
})
